/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_themes/EmbedTheme.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React from "react";
import {
  FormErrorBlock,
  FormInputs,
} from "../_sections";

type EmbedThemeProps = {
  togglePreview: () => void;
};

const EmbedTheme = ({
  togglePreview,
}: EmbedThemeProps) => {

  return (
    <>
      <FormInputs
        isEmbedded={true}
        togglePreview={togglePreview}
      />
      <FormErrorBlock />
    </>
  );
};

export default EmbedTheme;
